<template>
    <div>
        <desktop v-show="deviceStore.isDesktop" :data></desktop>
        <mobile v-show="deviceStore.isMobile" :data></mobile>
    </div>
</template>

<script setup>
import desktop from '~/pages/desktop/index.vue';
import mobile from '~/pages/mobile/index.vue';
import { usePageData } from '~/composables/usePageData';

// 启用页面缓存
definePageMeta({
    keepalive: true
});

// 使用 composable 加载页面数据（自动从路由参数中获取 id）
const { data, deviceStore, initData } = usePageData({
    enableKeepalive: true,
    logPrefix: 'ID2'
});

// 首次加载时获取数据
await initData();
</script>

<style lang="scss" scoped></style>